import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from 'projects/login/src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  private readonly _http = inject(HttpClient);

  private static retryUrlBacker: string | undefined = undefined;
  static get retryURl(): string {
    const url = this.retryUrlBacker ?? environment.invalidSessionRedirectUrl;
    if (this.isSafeUrl(url)) {
      return url;
    }

    return environment.invalidSessionRedirectUrl;
  }

  static set retryURl(retryUrl: string | undefined | null) {
    this.retryUrlBacker = retryUrl ?? undefined;
  }

  basePath: string = environment.authUrl + '/v2/authentication';

  public static sessionId: string | null;
  public static password: string | null;
  public static username: string | null;
  public static logoutReason?: string;

  set accessToken(token: string | undefined) {
    if (!token) {
      sessionStorage.removeItem('accessToken');
      return;
    }

    sessionStorage.setItem('accessToken', token);
  }

  get accessToken() {
    return sessionStorage.getItem('accessToken') ?? undefined;
  }

  createDefaultSession() {
    return this._http.post<{
      sessionId: string;
      redirectUrl: string;
    }>(`${this.basePath}/sessions`, {
      context: {
        scope: environment.activation.scope,
        returnUrl: environment.activation.returnUrl,
        flow: 'regular',
        intendedUrl: environment.activation.intendUrl,
      },
    });
  }

  private static getBaseDomain() {
    const hostname = window.location.hostname;
    const parts = hostname.split('.');

    if (parts.length >= 2) {
      return parts.slice(-2).join('.');
    }
    return hostname;
  }

  private static isSafeUrl(url: string) {
    if (!url) return false;

    try {
      const parsed = new URL(url, window.location.origin);

      if (!['http:', 'https:'].includes(parsed.protocol)) {
        return false;
      }

      const baseDomain = this.getBaseDomain();
      return parsed.hostname === baseDomain || parsed.hostname.endsWith('.' + baseDomain);
    } catch {
      return false;
    }
  }
}
